import Chart from 'react-apexcharts';

const StateWiseBarChart = ({ stateWiseData }) => {
    const categories = stateWiseData?.map(item => item?.state);
    const seriesData = stateWiseData?.map(item => item?.count);

    // Check if all values in `seriesData` are 0
    const isAllZero = seriesData.every(count => count === 0);

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        xaxis: {
            categories,
            labels: {
                style: { fontSize: "14px", fontWeight: "500", colors: "#666" },
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "45%",
            },
        },
        dataLabels: { enabled: false },
        legend: {
            position: "bottom",
            fontSize: "14px",
            labels: { colors: "#333" },
        },
        grid: {
            borderColor: "#E0E0E0",
            strokeDashArray: 4,
        },
        colors: isAllZero ? ["#000000"] : ["#1E90FF", "#87CEEB"], // Black bars if all data is 0
        fill: {
            type: "gradient",
            gradient: {
                type: "vertical",
                gradientToColors: isAllZero ? ["#000000"] : ["#87CEEB"],
                stops: [0, 100],
            },
        },
    };

    const series = [{ name: 'Orders', data: seriesData.length > 0 ? seriesData : [0] }];

    return (
        <div className="w-full">
            <Chart
                options={options}
                series={series}
                type="bar"
                width="100%"
                height={300}
            />
        </div>
    );
};

export default StateWiseBarChart;
